import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ForIndividuals() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 sm:pt-40 lg:pt-56 pb-12 sm:pb-16 lg:pb-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight">
            A system you don't think about — until you're grateful it exists.
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 mb-6 sm:mb-8 font-normal leading-relaxed">
            Halvera is built for people whose life gets expensive when things go wrong.
          </p>
          <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10 text-sm sm:text-base lg:text-lg text-gray-700 font-normal">
            <p>You may travel for work.</p>
            <p>You may live across cities or borders.</p>
            <p>You may simply value calm over chaos.</p>
          </div>
          <p className="text-base sm:text-lg lg:text-xl text-gray-900 font-semibold">
            Halvera gives you one place to turn when you don't want to deal with it.
          </p>
        </div>
      </section>

      {/* What You Gain */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 lg:mb-12 text-center">
            What You Gain
          </h2>
          <ul className="space-y-5 sm:space-y-6 lg:space-y-8 mb-10 sm:mb-12 lg:mb-16">
            <li className="flex items-start gap-4 sm:gap-5">
              <div className="w-2 h-2 bg-red-600 rounded-full mt-2.5 flex-shrink-0"></div>
              <span className="text-base sm:text-lg lg:text-xl text-gray-700 font-normal leading-relaxed">
                One system instead of many services
              </span>
            </li>
            <li className="flex items-start gap-4 sm:gap-5">
              <div className="w-2 h-2 bg-red-600 rounded-full mt-2.5 flex-shrink-0"></div>
              <span className="text-base sm:text-lg lg:text-xl text-gray-700 font-normal leading-relaxed">
                Faster resolution when things break
              </span>
            </li>
            <li className="flex items-start gap-4 sm:gap-5">
              <div className="w-2 h-2 bg-red-600 rounded-full mt-2.5 flex-shrink-0"></div>
              <span className="text-base sm:text-lg lg:text-xl text-gray-700 font-normal leading-relaxed">
                Less mental load during disruption
              </span>
            </li>
            <li className="flex items-start gap-4 sm:gap-5">
              <div className="w-2 h-2 bg-red-600 rounded-full mt-2.5 flex-shrink-0"></div>
              <span className="text-base sm:text-lg lg:text-xl text-gray-700 font-normal leading-relaxed">
                No need to explain context repeatedly
              </span>
            </li>
          </ul>
          <div className="bg-white p-6 sm:p-8 lg:p-10 rounded-lg border-2 border-gray-200 text-center">
            <p className="text-base sm:text-lg lg:text-xl text-gray-900 font-normal mb-2 sm:mb-3">
              This isn't a booking site.
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-gray-900 font-semibold">
              It's a safety net for momentum.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <Link 
            to="/apply" 
            className="inline-flex items-center px-8 sm:px-10 py-3 sm:py-4 bg-red-600 text-white rounded-md text-sm sm:text-base font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            Apply for Individual Access
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
